import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Toaster } from 'react-hot-toast';
import ScrollToTop from './ScrollToTop';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="1083740285274-tvvsachfqqlh5o9818f77dh55kko0nvs.apps.googleusercontent.com">
      <App />
      <Toaster
        position="top-right"
        reverseOrder={true}
      />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
document.addEventListener("DOMContentLoaded", function () {
  const isDark = localStorage.getItem("isDark");
  // console.log('isDark', isDark);

  if (isDark) {
    document.body.style.backgroundColor = "#1a1a1e";
    // import("flatpickr/dist/themes/dark.css");
  } else {
    document.body.style.backgroundColor = "#F2F2F2";
    // import("flatpickr/dist/themes/light.css");
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
